import React from "react";

// One printed photo taped to the wall. The frame keeps a fixed aspect ratio so
// the grid never shifts while images load, and the tilt is applied on the outer
// element so hover can straighten it.
const PolaroidPhoto = ({
  src,
  alt,
  year,
  caption,
  rotation = 0,
  featured = false,
  priority = false,
}) => (
  <figure
    className={`rm-polaroid${featured ? " rm-polaroid--featured" : ""}`}
    style={{ "--rm-rotation": `${rotation}deg` }}
  >
    <span className="rm-polaroid__tape" aria-hidden="true" />
    <div className="rm-polaroid__frame">
      <img
        src={src}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
      />
    </div>
    {(year || caption) && (
      <figcaption className="rm-polaroid__caption">
        {caption && <span className="rm-polaroid__caption-text">{caption}</span>}
        {year && (
          <span className="rm-polaroid__year" dir="ltr">
            {year}
          </span>
        )}
      </figcaption>
    )}
  </figure>
);

export default PolaroidPhoto;
